import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoHead from '@/components/feature/SeoHead';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhyUsSection from './components/WhyUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Mitigation Restoration Services',
    description: 'Comprehensive damage assessment, emergency cleanup, and full property restoration in Houston TX. Certified team, 60-min response.',
    url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
    telephone: '+18005551234',
    email: 'info@mrsrestore.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '1234 Restoration Ave',
      addressLocality: 'Houston',
      addressRegion: 'TX',
      postalCode: '77001',
      addressCountry: 'US',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 29.7604,
      longitude: -95.3698,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '18:00',
      },
    ],
    areaServed: {
      '@type': 'City',
      name: 'Houston',
    },
    serviceType: [
      'Emergency Cleanup',
      'Property Restoration',
      'Pipe Leak Repair',
      'Drainage Cleaning',
      'Mold Remediation',
      'Fire & Smoke Damage Restoration',
    ],
    priceRange: '$$',
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Mitigation Restoration Services',
    url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Mitigation Restoration Services | Emergency Cleanup & Property Restoration Houston TX"
        description="Mitigation Restoration Services provides 24/7 emergency cleanup, full property restoration, pipe leak repair, and drainage cleaning in Houston TX. Certified team, 60-min response."
        keywords="mitigation restoration, emergency cleanup, property restoration, pipe leak repair, drainage cleaning, Houston TX"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`}
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <WhyUsSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
